import { inView, timeline } from "motion";

const init = () => {
  const timelineItems = document.querySelectorAll(".timeline-item");

  timelineItems.forEach((item) => {
    inView(
      item,
      () => {
        timeline([
          [
            item.querySelector(".timeline-image"),
            {
              opacity: 1,
              transform: "translate3d(0, 0, 0)",
            },
            { duration: 0.5 },
          ],
          [
            item.querySelector(".timeline-indicator"),
            {
              scaleX: [0, 1],
            },
            { duration: 0.25 },
          ],
          [
            item.querySelector(".timeline-indicator-box"),
            {
              scale: [0, 1],
            },
            { duration: 0.25 },
          ],
          [
            item.querySelector(".timeline-date p:first-child"),
            {
              opacity: 1,
              scale: [1.2, 1],
            },
            { duration: 0.5 },
          ],
          [
            item.querySelector(".timeline-date p:last-child"),
            {
              opacity: 1,
              transform: "translate3d(0, 0, 0)",
            },
            { duration: 0.5, at: "<" },
          ],
          [
            item.querySelector(".timeline-content"),
            {
              opacity: 1,
              transform: "translate3d(0, 0, 0)",
            },
            { duration: 0.8, at: "<50%" },
          ],
        ]);
      },
      {
        margin: "0px 0px -25% 0px",
      },
    );
  });
};

if (window.matchMedia("(prefers-reduced-motion: no-preference)").matches) {
  init();
}
